module.exports = __webpack_public_path__ + "static/media/bucklescript.e4cba461.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bucklescript.png
// module id = 47
// module chunks = 0